const STOP = {
  en: "a an the of for to in on and or with my your how do i is it can",
  it: "il lo la le li gli i un una uno di del della dei delle per a al alla da in con e o su come mio mia",
  es: "el la los las un una unos unas de del para por a al en con y o mi tu como",
  fr: "le la les un une des de du d l pour par a au aux en et ou avec mon ma mes comment",
  de: "der die das den dem des ein eine einen einem für zu zum zur im in mit und oder mein wie",
  pt: "o a os as um uma de do da dos das para por em no na com e ou meu minha como",
  nl: "de het een van voor naar in op met en of mijn hoe",
  pl: "w z na do i o dla jak mój moja się",
  tr: "ve ile bir için de da nasıl",
  ar: "في من على إلى عن مع و أو كيف",
};
const CJK = new Set(["ja", "zh"]);

const norm = (s) => s.toLowerCase().normalize("NFD").replace(/\p{M}/gu, "");

export const searchArticles = (arts, query, lang) => {
  const q = norm(query.trim());
  if (!q) return arts;
  const text = (a) => norm(Object.values(a).join(" "));
  if (CJK.has(lang)) {
    const needle = q.replace(/\s+/g, "");
    return arts.filter(([, a]) => text(a).replace(/\s+/g, "").includes(needle));
  }
  const stop = new Set(norm(STOP[lang] || STOP.en).split(" "));
  const all = q.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
  const tokens = all.filter((w) => !stop.has(w));
  const use = tokens.length ? tokens : all;
  return arts.filter(([, a]) => { const tx = text(a); return use.every((w) => tx.includes(w)); });
};
